import { Location } from '@cobliteam/common-types';
import type { SetupGuideEntityId } from './entityModalConfig';

/**
 * Destino do botão "Configurações avançadas" das modais do Guia (AE-2499).
 *
 * O comportamento esperado é cair na página do fluxo **com a modal/drawer de criação já aberta** —
 * "convidar usuários" leva à página de usuários com o drawer de convite aberto, e assim por diante.
 * Cada página expõe isso de um jeito próprio, então o deep-link é registrado aqui em vez de montado
 * no componente.
 *
 * Etapas ausentes deste registry caem na rota simples da etapa (`item.route`), sem deep-link:
 * - `device-association`: a associação na página de dispositivos exige um dispositivo já selecionado
 *   na tabela (o fluxo é dirigido por store, não por URL) — não há alvo para abrir direto.
 * - `speed`: a página de velocidade por via não tem fluxo de criação; o limite por porte que a etapa
 *   configura vive no cadastro de veículos.
 */
export const SETUP_GUIDE_ADVANCED_SETTINGS: Partial<Record<SetupGuideEntityId, string>> = {
  // A página de usuários passou a ler `?create=true` (AE-2499); as outras três já eram deep-linkáveis.
  users: `${Location.CONFIG_USERS}?create=true`,
  // `driverId`/`vehicleId` = "new" é o contrato que essas páginas já usam para o drawer de criação.
  drivers: `${Location.DRIVER_MANAGEMENT}?driverId=new`,
  vehicles: `${Location.VEHICLES}?vehicleId=new`,
  // A rota de grupo já trata o id "new" como criação.
  groups: `${Location.VEHICLES_GROUPS}/new`,
};

/** Deep-link da etapa, ou `fallbackRoute` quando ela não tem uma tela de criação endereçável. */
export const getAdvancedSettingsRoute = (id: SetupGuideEntityId, fallbackRoute: string): string => SETUP_GUIDE_ADVANCED_SETTINGS[id] ?? fallbackRoute;
